import { render, staticRenderFns } from "./FavoritesCategories.vue?vue&type=template&id=04b1a4a4"
import script from "./FavoritesCategories.vue?vue&type=script&lang=js"
export * from "./FavoritesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports